export enum ESamplingRate {
  RATE_17_102400 = 'RATE_17_102400',
  RATE_16_51200 = 'RATE_16_51200',
  // Для отладки нового акселерометра (mcm-942)
  RATE_24_32000 = 'RATE_24_32000',
  RATE_15_25600 = 'RATE_15_25600',
  // Для отладки нового акселерометра (mcm-942)
  RATE_23_16000 = 'RATE_23_16000',
  RATE_14_12800 = 'RATE_14_12800',
  // Для отладки нового акселерометра (mcm-942)
  RATE_22_8000 = 'RATE_22_8000',
  RATE_13_6400 = 'RATE_13_6400',
  // Для отладки нового акселерометра (mcm-942)
  RATE_21_4000 = 'RATE_21_4000',
  RATE_12_3200 = 'RATE_12_3200',
  // Для отладки нового акселерометра (mcm-942)
  RATE_20_2000 = 'RATE_20_2000',
  RATE_11_1600 = 'RATE_11_1600',
  // Для отладки нового акселерометра (mcm-942)
  RATE_19_1000 = 'RATE_19_1000',
  RATE_10_800 = 'RATE_10_800',
  // Для отладки нового акселерометра (mcm-942)
  RATE_18_500 = 'RATE_18_500',
  RATE_09_400 = 'RATE_09_400',
  RATE_08_200 = 'RATE_08_200',
  RATE_07_100 = 'RATE_07_100',
  RATE_06_50 = 'RATE_06_50',
  RATE_05_25 = 'RATE_05_25',
  RATE_04_12 = 'RATE_04_12',
  RATE_04_6_25 = 'RATE_04_6_25',
  RATE_02_3_125 = 'RATE_02_3_125',
  RATE_01_1_563 = 'RATE_01_1_563',
  RATE_00_0_781 = 'RATE_00_0_781'
}

export const enum ELtr24SamplingRate {
  LTR24_FREQ_117K = 'LTR24_FREQ_117K',
  LTR24_FREQ_58K = 'LTR24_FREQ_58K',
  LTR24_FREQ_29K = 'LTR24_FREQ_29K',
  LTR24_FREQ_14K = 'LTR24_FREQ_14K',
  LTR24_FREQ_7K3 = 'LTR24_FREQ_7K3',
  LTR24_FREQ_3K6 = 'LTR24_FREQ_3K6',
  LTR24_FREQ_1K8 = 'LTR24_FREQ_1K8',
  LTR24_FREQ_915 = 'LTR24_FREQ_915'
}
